import gql from 'graphql-tag';

export const FETCH_PICKING_ORDER_QUERY = gql`
  query FetchPickingOrderQuery {
    pickingOrder {
      sku
      position
    }
  }
`;

export const START_PICKING_MUTATION = gql`
  mutation StartPickingMutation($input: StartPicking!) {
    startPicking(input: $input) {
      order
      distributionCenter
      packageSize
      first
      second
      rejectedBatches {
        code
      }
      promotionalItems {
        name
        title
        image
      }
      hasBoughtGreenGrocer
      pickingMode
      boxPickingItems {
        sku
        quantity
        shelfLifeDays
      }
      minShelfLifePercent
    }
  }
`;

export const PRINT_TAGS_MUTATION = gql`
  mutation PrintTagsMutation($input: PrintTag!) {
    printTags(input: $input)
  }
`;

export const PRINT_TAG_SSE_MUTATION = gql`
  mutation PrintTagSseMutation($input: PrintTagSSEInput!) {
    printTagSSE(input: $input)
  }
`;

export const GET_TAG_QUERY = gql`
  query GetTagQuery($input: GetTag!) {
    getTag(input: $input)
  }
`;

export const RETAIL_BOX_LABELS_QUERY = gql`
  query RetailBoxLabelsQuery($input: RetailBoxLabelsInput!) {
    retailBoxLabels(input: $input) {
      zpl
      total
      packageCount
      multiLabelPackages {
        number
        labelCount
      }
      from
      to
      warnings
    }
  }
`;

export const PRINT_RETAIL_BOX_LABELS_QUEUE_MUTATION = gql`
  mutation PrintRetailBoxLabelsQueueMutation($input: PrintRetailBoxLabelsQueueInput!) {
    printRetailBoxLabelsQueue(input: $input) {
      total
      packageCount
      from
      to
      warnings
    }
  }
`;

export const PRINT_RETAIL_BOX_LABELS_SSE_MUTATION = gql`
  mutation PrintRetailBoxLabelsSseMutation($input: PrintRetailBoxLabelsSSEInput!) {
    printRetailBoxLabelsSSE(input: $input) {
      total
      packageCount
      from
      to
      warnings
    }
  }
`;

export const FINISH_PICKING_MUTATION = gql`
  mutation FinishPickingMutation($input: FinishPicking!) {
    finishPicking(input: $input)
  }
`;

export const CANCEL_PICKING_MUTATION = gql`
  mutation CancelPickingMutation($input: CancelPicking!) {
    cancelPicking(input: $input)
  }
`;

export const LOG_EVENT_MUTATION = gql`
  mutation LogEventMutation($input: LogEvent!) {
    logEvent(input: $input)
  }
`;

export const FETCH_SALE = gql`
  query FetchSaleQuery($order: Float!) {
    sale(order: $order) {
      id
      user {
        name
        cpf
      }
      logisticKind
      observations
      insideObservations {
        text
      }
      isUrgent
      cart {
        deliverySettings {
          chosenPeriod {
            id
          }
          chosenDateString
          deliveryModifier
        }
        items {
          quantity
          kind
          ... on ProductCartItem {
            item {
              sku
              name
              type
            }
          }
          ... on MealCartItem {
            item {
              sku
              name
              type
              products
            }
          }
          ... on KitCartItem {
            item {
              sku
              name
              type
              breakfast {
                day
                products {
                  product {
                    sku
                    name
                    type
                  }
                }
              }
              midmorning {
                day
                products {
                  product {
                    sku
                    name
                    type
                  }
                }
              }
              lunch {
                day
                products {
                  product {
                    sku
                    name
                    type
                  }
                }
              }
              midafternoon {
                day
                products {
                  product {
                    sku
                    name
                    type
                  }
                }
              }
              dinner {
                day
                products {
                  product {
                    sku
                    name
                    type
                  }
                }
              }
              supper {
                day
                products {
                  product {
                    sku
                    name
                    type
                  }
                }
              }
              other {
                day
                products {
                  product {
                    sku
                    name
                    type
                  }
                }
              }
            }
          }
        }
      }
      products {
        id
        sku
        name
        color
        type
        expiration
        expirationCut
        pickingPriority
        fiscal {
          barcode
        }
        catalogueCategories {
          id
        }
      }
    }
  }
`;
